import React from "react"
import ExcelJS from "exceljs"
import { saveAs } from "file-saver"
import { Button } from "react-bootstrap"
import {
   commonViewColumns,
   sbmCommonViewsCols,
   accepedandRejectedCommonViewColumns,
   sbmCommonViewsColsAcceptedandRejected,
} from "../../constant/Constants"

function ExportToExcelAllSpecifications(props) {
   const { data, view } = props
   
   // Validate props
   if (!data) {
      console.error("ExportToExcelAllSpecifications: data prop is required")
      return null
   }

   const fullData = { ...data }
   
   // Remove null values and favorite
   for (const viewData in fullData) {
      if (fullData[viewData] === null || viewData === "favorite") {
         delete fullData[viewData]
      }
   }

   const userType = localStorage.getItem("userType")
   const currentView = sessionStorage.getItem("view")

   let columns

   const getFlattenedData = (data, key) => {
      if (!Array.isArray(data)) {
         console.error(`getFlattenedData: Expected array, got ${typeof data}`)
         return []
      }

      const sortedData = data.sort((a, b) => {
         if (a.EBPModified && b.EBPModified) {
            return new Date(b.EBPModified) - new Date(a.EBPModified)
         }
         return 0
      })

      return sortedData.reduce((acc, record) => {
         if (!record) return acc

         const isAcceptedOrRejected = key === "accepted" || key === "rejected"
         const isPGView = userType === "PG" && currentView === "PG"
         const isSBMView = (userType === "PG" || userType === "SBM") && currentView === "SBM"

         // Common record data
         const baseRecord = {
            Name: record.Name || "",
            Type: record.Type || "",
            SpecSubType: record.SpecSubType || "",
            AffRev: record.Rev || "",
            AffTitle: record.Title || "",
            ReasonForChange: record.ReasonForChange || "",
            ReleaseDate: record.ReleaseDate || "",
            EBPModified: record.EBPModified || "",
         }

         // Handle PG view
         if (isPGView) {
            if (isAcceptedOrRejected) {
               columns = accepedandRejectedCommonViewColumns
               if (!record.ImpactedParts || record.ImpactedParts.length === 0) {
                  acc.push({
                     ...baseRecord,
                     "Impacted Part": "",
                     "Display Type": "",
                     Rev: "",
                     Title: "",
                     "Action Taken On": record.actionTakenOn || "",
                     "Action Taken By": record.actionTakenBy || "",
                  })
               } else {
                  const impactedParts = view !== "Search" 
                     ? record.ImpactedParts.slice(0, 5) 
                     : record.ImpactedParts
                  
                  impactedParts.forEach((element) => {
                     acc.push({
                        ...baseRecord,
                        "Impacted Part": element.Name || "",
                        "Display Type": element.DisplayType || "",
                        Revision: element.Revision || "",
                        ImpactedTitle: element.Title || "",
                        "Action Taken On": record.actionTakenOn || "",
                        "Action Taken By": record.actionTakenBy || "",
                     })
                  })
               }
            } else {
               columns = commonViewColumns
               if (!record.ImpactedParts || record.ImpactedParts.length === 0) {
                  acc.push({
                     ...baseRecord,
                     "Impacted Part": "",
                     "Display Type": "",
                     Rev: "",
                     Title: "",
                  })
               } else {
                  const impactedParts = view !== "Search" 
                     ? record.ImpactedParts.slice(0, 5) 
                     : record.ImpactedParts
                  
                  impactedParts.forEach((element) => {
                     acc.push({
                        ...baseRecord,
                        "Impacted Part": element.Name || "",
                        "Display Type": element.DisplayType || "",
                        Revision: element.Revision || "",
                        ImpactedTitle: element.Title || "",
                     })
                  })
               }
            }
         }
         // Handle SBM view
         else if (isSBMView) {
            if (isAcceptedOrRejected) {
               columns = sbmCommonViewsColsAcceptedandRejected
               acc.push({
                  ...baseRecord,
                  "Action Taken On": record.actionTakenOn || "",
               })
            } else {
               columns = sbmCommonViewsCols
               acc.push(baseRecord)
            }
         }

         return acc
      }, [])
   }

   const AllSpecification = {
      pending: "Pending Specifications",
      accepted: "Accepted Specifications",
      favorite: "Favorites Specifications",
      rejected: "Rejected Specifications",
   }

   const handleExportAll = async () => {
      try {
         const siteInfo = document.getElementById("site")
         if (!siteInfo) {
            console.error("Site selector not found")
            return
         }

         const siteInfoVal = siteInfo.options[siteInfo.selectedIndex].value
         const workbook = new ExcelJS.Workbook()

         // Create a worksheet for each view
         Object.keys(fullData).forEach((key) => {
            const dataArray = fullData[key]
            if (!Array.isArray(dataArray) || dataArray.length === 0) {
               return
            }

            const flattenedData = getFlattenedData(dataArray, key)
            if (flattenedData.length === 0) {
               return
            }

            const worksheet = workbook.addWorksheet(AllSpecification[key] || key)

            // Determine which columns to use based on the view
            let sheetColumns
            if (key === "accepted" || key === "rejected") {
               sheetColumns =
                  userType === "SBM" && currentView === "SBM"
                     ? sbmCommonViewsColsAcceptedandRejected
                     : accepedandRejectedCommonViewColumns
            } else {
               sheetColumns =
                  userType === "SBM" && currentView === "SBM"
                     ? sbmCommonViewsCols
                     : commonViewColumns
            }

            // Add headers
            const headers = sheetColumns.map((col) => col.label)
            worksheet.addRow(headers)

            // Style the header row
            worksheet.getRow(1).font = { bold: true }
            worksheet.getRow(1).fill = {
               type: "pattern",
               pattern: "solid",
               fgColor: { argb: "FFD3D3D3" },
            }

            // Add data rows
            flattenedData.forEach((item) => {
               const row = sheetColumns.map((col) => item[col.value] || "")
               worksheet.addRow(row)
            })

            // Auto-fit columns
            worksheet.columns.forEach((column, index) => {
               let maxLength = headers[index]?.length || 10
               column.eachCell({ includeEmpty: false }, (cell) => {
                  const columnLength = cell.value ? cell.value.toString().length : 10
                  if (columnLength > maxLength) {
                     maxLength = columnLength
                  }
               })
               column.width = maxLength < 10 ? 10 : maxLength + 2
            })
         })

         // Generate buffer and download
         const buffer = await workbook.xlsx.writeBuffer()
         const blob = new Blob([buffer], {
            type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
         })
         saveAs(blob, `${siteInfoVal}.xlsx`)
      } catch (error) {
         console.error("Error exporting to Excel:", error)
         alert("Failed to export data. Please try again.")
      }
   }

   return (
      <Button style={{ margin: "5px" }} onClick={handleExportAll}>
         Export All Views
      </Button>
   )
}

export default ExportToExcelAllSpecifications